export default [
  {
    path: '/transfer',
    name: 'transfer',
    component: () => import('./Transfers.vue'),
    meta: {
      requiresAuth: true,
      is_admin: true,
      name: 'transfer',
    },
  },
]
